import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-contactlist',
  templateUrl: './contactlist.component.html',
  styleUrls: ['./contactlist.component.scss'],
})
export class ContactlistComponent implements OnInit {
  @Output() NotifyListfetch = new EventEmitter<any>();
  @Output() NotifyItemSelected = new EventEmitter<any>();
  @Output() NotifyListfetchRole = new EventEmitter<any>();
  @Input()  objectList:any=[];
  @Input()  stateCtrlValue:string;
  @Input()  isRolePopup:boolean=false;
  @Input()  isCompanyPopup:boolean=false;
  @Input()  isSharedAccessRolePopup:boolean=false;
  @Input()  isReviewerPopup:boolean=false;
  
  
  placeholder:string=''; 

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  roleInputCurrentvalue:any;
  stateCtrSendlValue: any;
  SelectedModuleName:any=[]=[];

  constructor() {
    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isReviewerPopup;
    this.isRolePopup;
    this.isCompanyPopup;
    this.isSharedAccessRolePopup;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    //this.CCCList = menuModulesList.filter(x => x.mainModuleName == 'Core' || x.mainModuleName == 'Contact' ||x.mainModuleName == 'Company' );
    this.SelectedModuleName = menuModulesList.filter(x => x.mainModuleName == 'Contact');
    if(this.isCompanyPopup){
      this.SelectedModuleName = menuModulesList.filter(x => x.mainModuleName == 'Company');
     // this.placeholder='Add Company';
     this.placeholder='Search '+ this.SelectedModuleName[0].orgModuleName;
    }
    else{
      //this.placeholder='Add Contact1';
      if(this.SelectedModuleName.length>0){
        this.placeholder='Search '+ this.SelectedModuleName[0].orgModuleName;
      }else{
        this.placeholder='Search Email';
      }
     
    }
  }


  ngOnInit(): void {}
  
  private _filterStates(value: string): State[] {    
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }
    
  search(value:any,isrole:boolean){
    this.stateCtrSendlValue=value;
    this.NotifyListfetch.emit(value);
  }

  onclickContact(searchValue: string){
    // if(searchValue==""){
    //   this.objectList=[];
    // }
  }

  selected(item:any,isRole:boolean) {
    if(isRole && item.transctionalRoleID=="0") {
      item.transactionalRoleName=this.roleInputCurrentvalue;
    }
    item.currentValue=this.stateCtrSendlValue;
    this.stateCtrl.setValue('');
    this.NotifyItemSelected.emit(item);
    this.objectList=[];
  }
  

  states= this.objectList;

}
